/** True when URL looks like a raster/vector image suitable for <img src>. */
export function isShowcaseImageUrl(url) {
  const s = String(url || "").trim();
  if (!s) return false;
  if (/\.(mp3|wav|ogg|m4a|aac|flac)(\?|#|$)/i.test(s)) return false;
  if (/favicon/i.test(s)) return false;
  return /\.(jpe?g|png|gif|webp|svg|bmp)(\?|#|$)/i.test(s) || /\/media\/.*\.(jpe?g|png|gif|webp)/i.test(s);
}

export function isShowcaseVideoUrl(url) {
  const s = String(url || "").trim();
  return (
    /\.(mp4|webm|mov)(\?|#|$)/i.test(s) || s.includes("video")
  );
}

export function isShowcaseAudioUrl(url) {
  const s = String(url || "").trim();
  return /\.(mp3|wav|ogg|m4a|aac|flac)(\?|#|$)/i.test(s);
}
